<template>
    <div class="journey-assessment" :class="{'journey-assessment--old': item.superseded}">
        <button type="button" class="journey-assessment__summary" :aria-expanded="String(expanded)" @click="expanded = !expanded">
            <i class="far fa-comment-alt journey-assessment__icon" aria-hidden="true"></i>
            <span class="journey-assessment__period">{{ period }}<template v-if="item.whole_month"> · за весь месяц</template></span>
            <strong v-if="item.ktu !== null && item.ktu !== undefined" class="journey-assessment__ktu">КТУ {{ String(item.ktu).replace('.', ',') }}</strong>
            <span v-if="item.status && item.status !== 'Проверен'" class="journey-assessment__status">{{ item.status }}</span>
            <span v-if="preview" class="journey-assessment__preview">{{ preview }}</span>
            <span class="journey-assessment__chevron" aria-hidden="true">{{ expanded ? '⌃' : '⌄' }}</span>
            <span class="sr-only">{{ expanded ? 'Свернуть характеристику' : 'Раскрыть характеристику' }}</span>
        </button>
        <div v-if="expanded" class="journey-assessment__body">
            <p v-if="item.text">{{ item.text }}</p>
            <small v-if="item.author || item.author_user_id"><AssignmentAuthor :label="item.ktu !== null && item.ktu !== undefined ? 'Автор КТУ' : 'Автор'" :name="item.author" :user-id="item.author_user_id" fallback="не сохранён" /></small>
            <div v-for="(field, index) in item.fields" :key="index" class="journey-assessment__field">
                <strong>{{ field.label }}</strong><p>{{ field.value }}</p><small><AssignmentAuthor label="Автор" :name="field.author" :user-id="field.author_user_id" fallback="не сохранён" /></small>
            </div>
            <div v-if="item.evidence && item.evidence.length" class="journey-assessment__evidence">
                <span v-for="(evidence, index) in item.evidence" :key="index" :class="{'journey-assessment__positive': ['increase', 'up'].includes(evidence.direction)}">✓ {{ evidence.label }}<b v-if="evidence.critical"> · критичное</b></span>
            </div>
            <router-link v-if="item.href" :to="item.href">Открыть табель ↗</router-link>
            <details v-if="item.previous_versions && item.previous_versions.length" class="journey-assessment__versions">
                <summary>Прежние оценки · {{ item.previous_versions.length }}</summary>
                <employee-journey-assessment v-for="version in item.previous_versions" :key="version.id" :item="version" />
            </details>
        </div>
    </div>
</template>

<script>
import {assessmentPreview, formatDate, formatMonth} from './employeeJourneyPresentation';
import AssignmentAuthor from '@/components/AssignmentAuthor.vue';
export default {
    name: 'EmployeeJourneyAssessment',
    components: {AssignmentAuthor},
    props: {item: {type: Object, required: true}},
    data: () => ({expanded: false}),
    computed: {
        preview() { return assessmentPreview(this.item); },
        period() { return this.item.month ? formatMonth(this.item.month) : formatDate(this.item.date) || 'Дата неизвестна'; }
    }
};
</script>

<style scoped>
.journey-assessment { min-width: 0; font-size: .85rem; margin: 5px 0; background: #f7f5fa; border-left: 3px solid #9d83b7; border-radius: 3px; }
.journey-assessment--old { color: #76818d; }
.journey-assessment__summary { display: flex; flex-wrap: wrap; align-items: center; gap: 4px 8px; width: 100%; min-width: 0; padding: 6px 9px; border: 0; background: none; color: #364859; text-align: left; }
.journey-assessment__summary:hover { color: #1766a1; }
.journey-assessment__summary:focus-visible { outline: 2px solid #2476b5; outline-offset: 2px; }
.journey-assessment__icon { color: #88659f; }
.journey-assessment__period { color: #71637e; font-size: .78rem; }
.journey-assessment__ktu { white-space: nowrap; color: #654581; background: #e9def2; border-radius: 3px; padding: 2px 5px; font-size: .78rem; }
.journey-assessment__status { font-size: .75rem; color: #856326; }
.journey-assessment__preview { overflow: hidden; white-space: nowrap; text-overflow: ellipsis; flex-basis: 100%; order: 2; min-width: 0; line-height: 1.45; }
.journey-assessment__chevron { color: #477699; margin-left: auto; }
.journey-assessment__body { padding: 5px 9px 9px; overflow-wrap: anywhere; }
.journey-assessment__body p { margin: 2px 0 4px; white-space: pre-line; }
.journey-assessment__body small { color: #71808d; }
.journey-assessment__field { margin: 7px 0; }
.journey-assessment__field strong { font-size: 12px; }
.journey-assessment__evidence { display: flex; flex-wrap: wrap; gap: 4px; margin: 7px 0; }
.journey-assessment__evidence span { padding: 2px 5px; border-radius: 3px; background: #fff3dd; color: #76521c; font-size: 12px; }
.journey-assessment__evidence .journey-assessment__positive { background: #eaf6ec; color: #2d633c; }
.journey-assessment__versions { margin-top: 7px; }
.journey-assessment__versions summary { color: #216ba5; cursor: pointer; }
@media (max-width: 600px) { .journey-assessment__summary { flex-wrap: wrap; } .journey-assessment__preview { flex-basis: 100%; order: 2; } }
</style>
